import { render, staticRenderFns } from "./MonitoringKuli.vue?vue&type=template&id=126b22e1&scoped=true&"
import script from "./MonitoringKuli.vue?vue&type=script&lang=js&"
export * from "./MonitoringKuli.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringKuli.vue?vue&type=style&index=0&id=126b22e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b22e1",
  null
  
)

export default component.exports